(() => {
  const selector = '.pw-showcase-card__video';

  function play(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;
    const promise = video.play();
    if (promise && typeof promise.catch === 'function') promise.catch(() => {});
  }

  function initialise(root = document) {
    root.querySelectorAll(selector).forEach((video) => {
      play(video);
      video.addEventListener('canplay', () => play(video), { once: true });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initialise());
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) document.querySelectorAll(selector).forEach(play);
  });
  ['touchstart', 'pointerdown'].forEach((eventName) => {
    document.addEventListener(eventName, () => document.querySelectorAll(selector).forEach(play), { once: true, passive: true });
  });
})();
